import { handleFreeTrialStart } from '@src/state/payment/actions'
import { RootState } from '@src/state/types'
import {
  selectPlagLockText,
  selectPlagLockTextNoFreeTrial,
} from '@src/state/workspace/selectors'
import usePriceTest from '@src/utils/hooks/usePriceTest'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import PlagiarismIllustration from './assets/PlagiarismIllustration.svg'
import FreemiumPlagiarismLockContent from './FreemiumPlagiarismLockContent'
import { Container, PlagiarismIcon } from './styled'
import {
  PlagiarismLockDispatchProps,
  PlagiarismLockProps,
  PlagiarismLockStateProps,
} from './types'

export const PLAGIARISM_LOCK = 'plagiarism lock'
const PLAGIARISM_ICON_ALT = 'plagiarism'

export const PlagiarismLock: React.FunctionComponent<PlagiarismLockProps> = ({
  upgrade,
  plagiarismTextFreeTrial,
  plagiarismTextNoFreeTrial,
  site,
}) => {
  const { freeTrial } = usePriceTest({ site })
  return (
    <Container>
      <PlagiarismIcon alt={PLAGIARISM_ICON_ALT} src={PlagiarismIllustration} />
      <FreemiumPlagiarismLockContent
        upgrade={upgrade}
        plagiarismText={freeTrial ? plagiarismTextFreeTrial : plagiarismTextNoFreeTrial}
      />
    </Container>
  )
}

const mapStateToProps = (state: RootState): PlagiarismLockStateProps => ({
  plagiarismTextFreeTrial: selectPlagLockText(state),
  plagiarismTextNoFreeTrial: selectPlagLockTextNoFreeTrial(state),
  site: state.site,
})
const mapDispatchToProps = (dispatch: Dispatch) => ({
  upgrade: () => dispatch(handleFreeTrialStart(PLAGIARISM_LOCK)),
})

const ConnectedPlagiarismLock = connect<
  PlagiarismLockStateProps,
  PlagiarismLockDispatchProps
>(
  mapStateToProps,
  mapDispatchToProps
)(PlagiarismLock)

ConnectedPlagiarismLock.displayName = 'PlagiarismLock'

export default ConnectedPlagiarismLock



// WEBPACK FOOTER //
// ./src/components/PlagiarismLock/index.tsx